import { useLayoutEffect } from 'react';

export const useMarketingViewport = () => {
  useLayoutEffect(() => {
    document.documentElement.classList.add('homepage-viewport');
    return () => document.documentElement.classList.remove('homepage-viewport');
  }, []);
};